// @mui
import { Typography, Stack, Box, useTheme } from "@mui/material";
// components
import Logo from "../../components/logo";
import Image from "../../components/image";
//
import {
  StyledRoot,
  StyledSectionBg,
  StyledSection,
  StyledContent,
} from "./styles";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

import { motion } from "framer-motion";
import { NAV } from "../../config";
import useResponsive from "../../hooks/useResponsive";
import ShowLastUpdate from "../../components/CustomComponents.tsx/ShowLastUpdate";

// ----------------------------------------------------------------------

export default function GuestLayout() {
  const theme = useTheme();
  const isDesktop = useResponsive("up", "md");

  return (
    <StyledRoot>
      <Box
        component={motion.div}
        sx={{
          bgcolor: "background.default",
          width: "100%",
          position: "fixed",
          zIndex: 9,
        }}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
      >
        <Header />
      </Box>
      <StyledContent>
        <Stack sx={{ width: 1 }}>
          <Outlet />
        </Stack>
      </StyledContent>
      <ShowLastUpdate />

      {/* {isDesktop && (
        <Box
          component={motion.div}
          sx={{
            bgcolor: "background.default",
            width: "100%",
            position: "fixed",
            bottom: 0,
            zIndex: 9,
          }}
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <Footer />
        </Box>
      )} */}
    </StyledRoot>
  );
}
